import React from 'react';
import './Student.css'

const Student = (props) => {
    // console.log(props);
    const {student}=props;
    // console.log(student);
    const { strCutout, strPlayer, time, description }=student;
    return (
        <div className='student-info'>
            <img src={strCutout} alt="" />
            <h2>Name:{strPlayer}</h2>
            <p>Desc:{description}</p>
            <p>Time: <span>{time}min</span></p>
            <button className='btn-cls' onClick={()=>(props.handleAddToCart(student))}>AddCart</button>
            
        </div>
    );
};

export default Student;